import { Injectable } from '@angular/core';
import { AppUtil } from '../core/utility/app-util';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  url: string = AppUtil.addTrailingSlash(environment.URL_API_AUTH) + 'api/andessuiteidentity/'

  constructor(private http: HttpClient) { }

  validarIngreso(): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}consultar-usuario?idSistema=${environment.ID_SISTEMA}`);
  }
}
